import { render } from "./CalendarWrapper.vue?vue&type=template&id=f0b3f240"
import script from "./CalendarWrapper.vue?vue&type=script&lang=js"
export * from "./CalendarWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__